export default "__VITE_ASSET__Cjwx3L40__"